import React from "react";

/**
 * ClassSplitBar — small stacked bar showing the retro/development/customer
 * share of a year (or quarter) tile. Numbers are kWp so the split reflects
 * install capacity, not raw project count.
 */
export default function ClassSplitBar({ retro = 0, dev = 0, customer = 0, active = false }) {
  const total = retro + dev + customer;
  if (!total) return null;
  const rPct = (retro / total) * 100;
  const dPct = (dev / total) * 100;
  const cPct = (customer / total) * 100;
  return (
    <div className="mt-2" data-testid="pm-class-split-bar">
      <div className="h-1.5 rounded-full overflow-hidden flex" style={{ background: active ? "rgba(255,255,255,0.25)" : "var(--line)" }}>
        {rPct > 0 && <div style={{ width: `${rPct}%`, background: active ? "#fff" : "#00D6DF" }} />}
        {dPct > 0 && <div style={{ width: `${dPct}%`, background: active ? "rgba(255,255,255,0.75)" : "#B8721E" }} />}
        {cPct > 0 && <div style={{ width: `${cPct}%`, background: active ? "rgba(255,255,255,0.55)" : "#5B4B8A" }} />}
      </div>
      <div className={`flex justify-between text-[9px] mt-1 font-mono ${active ? "text-white/85" : "muted"}`}>
        <span>R {Math.round(rPct)}%</span>
        <span>D {Math.round(dPct)}%</span>
        <span>C {Math.round(cPct)}%</span>
      </div>
    </div>
  );
}
